import { Button, Css, Tag, useTestIds } from "@homebound/beam";
import { useState } from "react";
import { Card } from "src/components/Card";
import { PlanPackageOverviewV2_ReadyPlanOptionFragment } from "src/routes/libraries/plan-package-v2/components/OverviewTab.generated";
import { count } from "src/utils";

type ElevationsCardProps = { elevations: PlanPackageOverviewV2_ReadyPlanOptionFragment[]; exteriorSchemeCount: number };

export function ElevationsCard({ elevations, exteriorSchemeCount }: ElevationsCardProps) {
  const tid = useTestIds({}, "elevationsCard");
  const [expanded, setExpanded] = useState(false);
  // How many elevations to show before the "View All" toggle
  const initialCount = 3;

  return (
    <Card xss={Css.p3.boxShadow("none").$}>
      <h3 css={Css.lg.$} {...tid.title}>
        Elevations
      </h3>
      <ul css={Css.listReset.if(expanded).maxhPx(500).overflowY("auto").$}>
        {elevations.isEmpty ? (
          <div>No elevations added.</div>
        ) : (
          (expanded ? elevations : elevations.slice(0, initialCount)).map(({ id, code, name, programData }, i) => (
            <li key={id} css={Css.py2.if(i > 0).bt.bcGray200.$} {...tid.elevation}>
              <div css={Css.mdSb.$}>
                {i === 0 && (
                  <div css={Css.pb1.$}>
                    <Tag text="Default" type="info" />
                  </div>
                )}
                {code} - {name}
              </div>
              <div css={Css.df.gap2.sm.gray700.mtPx(4).$}>
                <span>{programData.sellableSqft} sqft</span>
                <span>{count(exteriorSchemeCount, "Exterior Elevation")}</span>
              </div>
            </li>
          ))
        )}
      </ul>
      {elevations.length > initialCount && (
        <div css={Css.df.jcfe.bt.bcGray200.$}>
          <Button
            variant="quaternary"
            label={expanded ? "View Less" : "View All"}
            onClick={() => setExpanded(!expanded)}
            {...tid.viewAll}
          />
        </div>
      )}
    </Card>
  );
}
